module.exports = __webpack_public_path__ + "img/Logo-AEJ.9a6012ec.png";